<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    {
      staticClass: "dropdown-notification mr-25",
      attrs: { "menu-class": "dropdown-menu-media", right: "" },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c("feather-icon", {
                staticClass: "text-body",
                attrs: {
                  badge: "6",
                  "badge-classes": "bg-danger",
                  icon: "BellIcon",
                  size: "21",
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("li", { staticClass: "dropdown-menu-header" }, [
        _c(
          "div",
          { staticClass: "dropdown-header d-flex" },
          [
            _c("h4", { staticClass: "notification-title mb-0 mr-auto" }, [
              _vm._v(" Notifications "),
            ]),
            _c("b-badge", { attrs: { pill: "", variant: "light-primary" } }, [
              _vm._v(" 6 New "),
            ]),
          ],
          1
        ),
      ]),
      _vm._m(0),
      _c(
        "li",
        { staticClass: "dropdown-menu-footer" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { 400: true },
                },
              ],
              attrs: { variant: "primary", block: "" },
            },
            [_vm._v("Read all notifications")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "vue-perfect-scrollbar",
      {
        staticClass: "scrollable-container media-list scroll-area",
        attrs: { settings: _vm.perfectScrollbarSettings, tagname: "li" },
      },
      [
        _vm._l(_vm.notifications, function (notification) {
          return _c(
            "b-link",
            { key: notification.subtitle },
            [
              _c(
                "b-media",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "aside",
                        fn: function () {
                          return [
                            _c("b-avatar", {
                              attrs: {
                                size: "32",
                                src: notification.avatar,
                                text: notification.avatar,
                                variant: notification.type,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("p", { staticClass: "media-heading" }, [
                    _c("span", { staticClass: "font-weight-bolder" }, [
                      _vm._v(" " + _vm._s(notification.title) + " "),
                    ]),
                  ]),
                  _c("small", { staticClass: "notification-text" }, [
                    _vm._v(_vm._s(notification.subtitle)),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        _c(
          "div",
          { staticClass: "media d-flex align-items-center" },
          [
            _c("h6", { staticClass: "font-weight-bolder mr-auto mb-0" }, [
              _vm._v(" System Notifications "),
            ]),
            _c("b-form-checkbox", { attrs: { checked: true, switch: "" } }),
          ],
          1
        ),
        _vm._l(_vm.systemNotifications, function (notification) {
          return _c(
            "b-link",
            { key: notification.subtitle },
            [
              _c(
                "b-media",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "aside",
                        fn: function () {
                          return [
                            _c(
                              "b-avatar",
                              {
                                attrs: {
                                  size: "32",
                                  variant: notification.type,
                                },
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: notification.icon },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("p", { staticClass: "media-heading" }, [
                    _c("span", { staticClass: "font-weight-bolder" }, [
                      _vm._v(" " + _vm._s(notification.title) + " "),
                    ]),
                  ]),
                  _c("small", { staticClass: "notification-text" }, [
                    _vm._v(_vm._s(notification.subtitle)),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
      ],
      2
    )
  },
]
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/components/app-navbar/components/NotificationDropdown.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Ripple from 'vue-ripple-directive';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




export default ({
  render,
  staticRenderFns,
  components: {
    BNavItemDropdown: bootstrapvue["BNavItemDropdown"],
    BBadge: bootstrapvue["BBadge"],
    BMedia: bootstrapvue["BMedia"],
    BLink: bootstrapvue["BLink"],
    BAvatar: bootstrapvue["BAvatar"],
    VuePerfectScrollbar: VuePerfectScrollbar,
    BButton: bootstrapvue["BButton"],
    BFormCheckbox: bootstrapvue["BFormCheckbox"]
  },
  directives: {
    Ripple
  },
  setup() {
    /* eslint-disable global-require */
    const notifications = [{
      title: 'Congratulation Sam 🎉',
      avatar: require("@/assets/images/avatars/6-small.png"),
      subtitle: 'Won the monthly best seller badge',
      type: 'light-success'
    }, {
      title: 'New message received',
      avatar: require("@/assets/images/avatars/9-small.png"),
      subtitle: 'You have 10 unread messages',
      type: 'light-info'
    }, {
      title: 'Revised Order 👋',
      avatar: 'MD',
      subtitle: 'MD Inc. order updated',
      type: 'light-danger'
    }];
    /* eslint-disable global-require */

    const systemNotifications = [{
      title: 'Server down',
      subtitle: 'USA Server is down due to hight CPU usage',
      type: 'light-danger',
      icon: 'XIcon'
    }, {
      title: 'Sales report generated',
      subtitle: 'Last month sales report generated',
      type: 'light-success',
      icon: 'CheckIcon'
    }, {
      title: 'High memory usage',
      subtitle: 'BLR Server using high memory',
      type: 'light-warning',
      icon: 'AlertTriangleIcon'
    }];
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false
    };
    return {
      notifications,
      systemNotifications,
      perfectScrollbarSettings
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/components/app-navbar/components/NotificationDropdown.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

